import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/apiv1";
import { changeOrganization } from "./session";

export enum RejectionReason {
	Network,
	Bug,
};

export type OrganizationUserStateInitializing = {
	kind: 'initializing',
	pending:  boolean,
	rejectionReason?: RejectionReason,
};

export type OrganizationUserStateReady = {
	kind: 'ready',
	organizationUsers: User[],
};

export type OrganizationUserState = OrganizationUserStateInitializing | OrganizationUserStateReady;

const initialState = {
	kind: 'initializing',
} as OrganizationUserState;

export const organizationUserSlice = createSlice({
	name: 'organizationUser',
	initialState,
	reducers: {
		reset: (state, action: PayloadAction<RejectionReason | undefined>): OrganizationUserState => {
			return {
				kind: 'initializing',
				pending: false,
				rejectionReason: action.payload,
			};
		},
		pending: (state): OrganizationUserState => {
			return {
				kind: 'initializing',
				pending: true,
			}
		},
		ready: (state, action: PayloadAction<User[]>): OrganizationUserState => {
			return {
				kind: 'ready',
				organizationUsers: action.payload,
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(changeOrganization, (): OrganizationUserState => {
			return {
				kind: 'initializing',
				pending: false,
			};
		})
	}
});

export const { reset, pending, ready } = organizationUserSlice.actions;
export default organizationUserSlice.reducer;
